/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html } from 'lit-all'
import styles from 'lib-styles'
import * as paths from 'lib-paths'
/* eslint-disable import/no-unresolved */

class HHQuantityInput extends BaseElement {
  static properties = {
    key: {},
    label: {},
    initial: {
      type: Number,
    },
    _value: {
      state: true,
    },
    classes: {
      type: String,
    },
  }

  constructor() {
    super()

    this.broadcast = this.broadcast.bind(this)
    this.id = Math.random() * 100000
  }

  connectedCallback() {
    super.connectedCallback()
    this._value = this.initial

    this.productTitle = window.__THEME_GLOBALS__.product.title
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('initial')) {
      this._value = this.initial
    }
  }

  broadcast() {
    const $input = this.querySelector('[slot="input"]')
    $input && ($input.value = this._value)

    this.dispatchEvent(
      new CustomEvent('changeQuantity', {
        bubbles: true,
        composed: true,
        detail: {
          key: this.key,
          value: this._value,
        },
      })
    )
  }

  increment() {
    this._value += 1
    this.broadcast()
  }

  decrement() {
    if (this._value === 1 || !this._value) {
      return
    }

    this._value -= 1
    this.broadcast()
  }

  override(e) {
    this._value = Math.max(0, e.target.value)
    this.broadcast()
  }

  render() {
    return html`
      <span>
        <div class="wrapper ${this.classes}">
          <button
            @click="${this.decrement}"
            name="decrease"
            aria-label="${window.__THEME_GLOBALS__.strings.quantity.decrease.replace(
              '{{ product }}',
              this.productTitle || ''
            )}"
          >
            ${paths.minus}
          </button>
          <label class="sr-only" for="Quantity-${this.id}">
            ${this.label || 'Quantity'}
          </label>
          <slot name="input"></slot>
          <input
            id="Quantity-${this.id}"
            class="input"
            type="number"
            name="updates[]"
            value="${this._value}"
            @change="${this.override}"
            min="1"
            aria-label="${window.__THEME_GLOBALS__.strings.quantity.label?.replace(
              '{{ product }}',
              this.productTitle || ''
            )}"
          />
          <button
            @click="${this.increment}"
            name="increase"
            aria-label="${window.__THEME_GLOBALS__.strings.quantity.increase?.replace(
              '{{ product }}',
              this.productTitle || ''
            )}"
          >
            ${paths.plus}
          </button>
        </div>
      </span>
    `
  }

  static styles = [
    styles.a11y,
    css`
      .wrapper {
        border: var(--border-width, 1px) solid
          var(--border-color, rgb(230, 230, 230));
        border-radius: var(--border-radius, 4px);
        box-sizing: border-box;
        color: var(--color, #000);
        background-color: var(--background, transparent);
        width: var(--width, 10rem);
        position: relative;
        display: flex;
        padding: var(--padding, 0 0.5rem);
        height: var(--height, 2rem);
      }
      .input {
        color: currentColor;
        background-color: var(--background, transparent);
        font: var(--font);
        text-align: center;
        background-color: transparent;
        border: 0;
        padding: var(--input-padding, 0 0.5rem);
        height: calc(var(--height, 2em) - 2px);
        width: 100%;
        flex-grow: 1;
        -webkit-appearance: none;
        appearance: none;
        -moz-appearance: textfield;
      }
      button {
        width: var(--button-width, 2.5rem);
        flex-shrink: 0;
        border: 0;
        background-color: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--button-color, var(--color, #000));
        padding: 0;
      }
      button:hover {
        color: var(--button-color-hover, var(--color, #000));
      }
      .input:-webkit-autofill,
      .input:-webkit-autofill:hover,
      .input:-webkit-autofill:active {
        box-shadow: 0 0 0 10rem var(--color-background) inset !important;
        -webkit-box-shadow: 0 0 0 10rem var(--color-background) inset !important;
      }
      .input::-webkit-outer-spin-button,
      .input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    `,
  ]
}

customElements.define('hh-quantity-input', HHQuantityInput)
